import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { env } from '@authy/lib-client/env'

import { Security } from '@/features/security'
import { NotFound } from '@/features/errors'

import { AccountLayout } from './AccountLayout'

export const App = () => {
    let accountPath = '/'

    if (window.location.origin === new URL(env.VITE_PRODUCT_URL_ACCOUNT).origin) {
        accountPath = '/t/:tenantSlug'
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path={accountPath} element={<AccountLayout />}>
                    <Route path="security" element={<Security />} />
                    <Route index element={<Navigate to="security" replace />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    )
}
